import React, { useState, useEffect, useRef } from "react";
import styles from "./PaymentSuccessfullBottomSheet.module.scss";
import { Image } from "@src/components/Image";
import Modal from "@src/components/UIElements/Modal";
import { addTokenInUrl, getAwsAssets } from "@src/utils";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import {
  getCourseDetailsAction,
  setPrevOrderId,
  updateIsInstallmentPaymentAction,
} from "@src/components/Tabs/Overview/store/actions";
import {
  showSelectAddressBottomSheetAction,
  showSelectStateBottomSheetAction,
} from "../../store/actions";
import { useTranslation } from "react-i18next";
import { useRouter } from "@src/lib/router";
import { getTabListAction } from "@src/components/UIElements/TabBar/store/actions";

import { newWebEngage } from "@src/utils/webEngageEvent";
import { hitDeeplinkExecutedV2 } from "@src/utils/hitDeeplink";
import { hitContentDeeplinkOld } from "../../../Tabs/Content/helpers/hitContentDeeplink";

const PaymentSuccessfullBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const showCongratulationsBottomSheet = useSelector(
    (state) => state?.bottomSheetReducer?.showCongratulationsBottomSheet
  );
  const bottomCard = useSelector(
    (state) => state?.bottomSheetReducer?.congratulationsBottomCard
  );

  const courseName = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.details?.name
  );

  const isInstallmentPayment = useSelector(
    (state) => state?.overviewReducer?.isInstallmentPayment
  );

  const router = useRouter();
  const courseId = router.query.courseId;

  const data = useSelector(
    (state) => state?.overviewReducer?.individualInstallmentData
  );

  let appliedCoupon = useSelector((state) => {
    return state?.overviewReducer?.graphCourseData?.appliedCoupon;
  });

  let priceValue = useSelector((state) => {
    return state?.overviewReducer?.graphCourseData?.priceBottom?.val;
  });
  let orgDetails = useSelector((state) => {
    return state?.persistedDataReducer?.orgDetails?.organization;
  });
  let userDetails = useSelector((state) => {
    return state?.overviewReducer?.userDetails?.responseData?.user;
  });
  let courseDetails = useSelector((state) => {
    return state?.overviewReducer?.overViewDetails?.course;
  });
  let orderId = window.localStorage.getItem("orderId");
  let setTimeoutRef = useRef();
  const isStandAloneUrl = useSelector((state) => state?.overviewReducer?.standAloneUrl) || "";
  const isStandAlone = useSelector((state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.doubtBuddyCourseFlag) || false;
  useEffect(() => {
    if (courseName && priceValue && orgDetails?.code && userDetails?.id) {
      newWebEngage("course_payment_successful", {
        action: "Payment Successful",
        course_name: `${courseName}`,
        amount: priceValue / 100,
        currency: "INR",
        value: `${priceValue / 100.00}`,
        transaction_id: orderId,
        item: [
          {
            item_id: courseDetails?.metaData?.id, 
            item_name: courseDetails?.details?.name, 
            item_category: courseDetails?.categoryList,
            price: courseDetails?.priceDetails?.coursePrice
          }
        ],
        ...(appliedCoupon?.code
          ? {
            coupon: appliedCoupon?.code + "",
            coupon_code: appliedCoupon?.code + "",
            is_coupon_applied: appliedCoupon?.redeemId ? `true` : `false`,
          }
          : { is_coupon_applied: `false` }),
      });
      dispatch(setPrevOrderId(null));
    }
  }, [courseName, priceValue, orgDetails, userDetails?.id]);

  useEffect(() => {
    setTimeoutRef.current = setTimeout(handleCloseSuccessPopup, 15000);
    return () => {
      stopCountdown();
    };
  }, []);

  useEffect(() => {
    dispatch(showSelectStateBottomSheetAction(false));
    dispatch(showSelectAddressBottomSheetAction(false));

  }, [showCongratulationsBottomSheet]);
  const token = useSelector((state) => state?.persistedDataReducer?.userToken);
   const isIdfysDocVerificationPrepurchase = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.verificationDetails?.prePurchase?.isVerificationRequired) || false;

  const handleCloseSuccessPopup = () => {
    dispatch(updateIsInstallmentPaymentAction(false));
    stopCountdown();
    window?.handleRefreshCourseData();
    window.scrollTo(0, 0);
    // dispatch(getTabListAction({ courseId: courseId, skipLoader: true }));
    // dispatch(
    //   getCourseDetailsAction({
    //     courseId: courseId,
    //     isLoading: false,
    //   })
    // );
    dispatch(
      actionCreator.showCongratulationsBottomSheetAction({
        show: false,
        bottomCard: null,
      })
    );
    if(isStandAloneUrl && isStandAlone ) {
      hitContentDeeplinkOld("UTIL_WEBVIEW", {paramOne: addTokenInUrl(isStandAloneUrl, token)}, true, true)
    }
    if(router.query?.tabId == 5){
      router.push(`/${router.query?.courseId}/1`);
    }
     if(router.query?.tabId == 2 && isIdfysDocVerificationPrepurchase){
      router.push(`/${router.query?.courseId}/1`);
    }
  };

  const stopCountdown = () => {
    clearInterval(setTimeoutRef.current);
  };

  const hitBottomCardDeeplink = () => {
    const stringifiedDeeplinkObj = JSON.stringify(bottomCard.deeplink);
    hitDeeplinkExecutedV2(stringifiedDeeplinkObj, stringifiedDeeplinkObj);
  };

  return (
    <Modal
      showModal={showCongratulationsBottomSheet}
      handleClose={() => {
        handleCloseSuccessPopup();
      }}
    >
      <div className={styles.PaidInstallment}>
        <div className={styles.PaidInstallment__image}>
          <Image
            src={getAwsAssets("CouponSuccess.gif", "Overview")}
            className="GIFCoupons"
            width="80"
            height="80"
            alt={t(
              "components.bottomSheets.components.paymentSuccessfullBottomSheet.couponSuccess",
              "CouponSuccess"
            )}
          />
        </div>
        <h1 className={styles.PaidInstallment__heading}>
          {t(
            "components.bottomSheets.components.paymentSuccessfullBottomSheet.congratulations",
            "Congratulations!"
          )}
        </h1>
        {isInstallmentPayment && data?.successfulPaymentInfo?.subText ? (
          <>
            <p className={styles.PaidInstallment__subtext}>
              {data?.successfulPaymentInfo?.subText1} for{" "}
              <span className={styles.PaidInstallment__subtext__bold}>
                {courseName}
              </span>
            </p>
            <p className={styles.PaidInstallment__subtext}>
              {t(
                "components.bottomSheets.components.paymentSuccessfullBottomSheet.startLearningText1",
                "Start learning now"
              )}
              . {data?.successfulPaymentInfo?.subText2}
            </p>
          </>
        ) : (
          <>
            <p className={styles.PaidInstallment__subtext}>
              {t(
                "components.bottomSheets.components.paymentSuccessfullBottomSheet.successfullyPurchasedText",
                "You have successfully purchased"
              )}{" "}
              <span className={styles.PaidInstallment__subtext__bold}>
                {courseName}
              </span>
            </p>
            <p className={styles.PaidInstallment__subtext}>
              {t(
                "components.bottomSheets.components.paymentSuccessfullBottomSheet.startLearningText2",
                "Start learning now"
              )}
              .{" "}
            </p>
          </>
        )}
        {!!bottomCard && (
          <>
            <div className={styles.bottomCard}>
              {t(
                "components.bottomSheets.components.paymentSuccessfullBottomSheet.rewardText",
                "You've won a new reward!"
              )}
            </div>
            <img src={bottomCard.imageUrl} onClick={hitBottomCardDeeplink} />
          </>
        )}
      </div>
    </Modal>
  );
};

export default PaymentSuccessfullBottomSheet;
